import { PlacesType } from "react-tooltip";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Counter, MyleCounterStyle } from "@/Common/Models/MyleMenu/Tooltip/Counters";
import { Tooltip } from "../Tooltip/Tooltip";

import styles from "./MyleMenuCounterTooltip.module.scss";

interface IMyleMenuCounterTooltipProps {
    counters: Counter[];
    anchor: string;
    place?: PlacesType;
}

function MyleMenuCounterTooltip(props: Readonly<IMyleMenuCounterTooltipProps>): JSX.Element {
    const { getText } = useTranslation();

    const getStyle = (style: MyleCounterStyle): string => {
        switch (style) {
            case MyleCounterStyle.blueCircleNoBackground:
                return styles.blueCircleNoBackground;
            case MyleCounterStyle.redCircleNoBackground:
                return styles.redCircleNoBackground;
            case MyleCounterStyle.redCircleWithBackground:
                return styles.redCircleWithBackground;
            default:
                return styles.blueCircleWithBackground;
        }
    };

    return (
        <Tooltip
            anchorSelect={props.anchor}
            place={props.place ?? "bottom-start"}
            openDelay={1000}
        >
            <div className={styles.section}>
                {props.counters?.map(counter => counter.value > 0 ? (
                    <div className={styles.line} key={counter.text}>
                        <div className={styles.box}>
                            <span className={`${styles.number} ${getStyle(counter.style)}`}>
                                {counter.value}
                            </span>
                        </div>
                        <div>{getText(counter.text)}</div>
                    </div>
                ) : null
                )}
            </div>
        </Tooltip>
    );
}

export { MyleMenuCounterTooltip };
